import React from 'react';
import {View, Image, StyleSheet} from 'react-native';
import {getOnboardingDescriber} from '../../descriptor/onboarding/DescriptorType';
import {getSubsidyCardStyles} from 'src/utils/subsidyCardUtils';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';
import CKLogoBW from 'src/components/img/svg/CKLogoBW';
import AramarkLogo from 'src/components/img/svg/AramarkLogo';
import RefiveSubsidyLogo from 'src/components/img/svg/RefiveSubsidyLogo';
import Logo from 'src/components/elements/Logo';

interface SubsidyLogoProps {
  logoUrl?: string;
  size?: number;
}

export const SubsidyLogo: React.FC<SubsidyLogoProps> = ({
  logoUrl,
  size = 40,
}) => {
  if (logoUrl) {
    return (
      <Image
        source={{uri: logoUrl}}
        style={[styles.logoImage, {width: size, height: size}]}
        resizeMode="contain"
        accessible={true}
        accessibilityRole="image"
        accessibilityLabel="Subsidy provider logo"
      />
    );
  }

  const {iconBackgroundColor} = getSubsidyCardStyles();
  const wrapperStyle = [
    styles.defaultLogoWrapper,
    {width: size, height: size},
    iconBackgroundColor &&
      iconBackgroundColor !== 'transparent' && {
        backgroundColor: iconBackgroundColor,
      },
  ];

  if (Settings.buildType === BuildTypeEnum.companykitchen) {
    return (
      <View style={wrapperStyle}>
        <CKLogoBW width={size} height={size} />
      </View>
    );
  }

  let logoContent: React.ReactNode | null = null;

  if (Settings.buildType === BuildTypeEnum.aramark) {
    logoContent = <AramarkLogo size={size} />;
  } else if (Settings.buildType === BuildTypeEnum.refive) {
    // For refive, render without wrapper to avoid clipping the "tm" text
    return <RefiveSubsidyLogo width={size} height={size} />;
  } else {
    const loginLogo = getOnboardingDescriber().getLoginLogo();
    if (React.isValidElement(loginLogo)) {
      logoContent = React.cloneElement(loginLogo, {
        width: size,
        height: size,
        style: undefined,
      });
    } else {
      logoContent = <Logo width={size} height={size} />;
    }
  }

  return <View style={wrapperStyle}>{logoContent}</View>;
};

const styles = StyleSheet.create({
  logoImage: {
    borderRadius: 8,
  },
  defaultLogoWrapper: {
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
});
